export const messages = {
  en: {
    activitiesManage: {
      search: {
        title: 'Search Conditions',
        activitiesId: 'Please enter activity ID',
        titlePlaceholder: 'Please enter title',
        typeCd: 'Please select activity type',
        staffName: 'Please enter publisher name'
      },
      list: {
        title: 'Activity List'
      },
      table: {
        activitiesId: 'Activity ID',
        title: 'Title',
        typeCd: 'Type',
        startTime: 'Start Time',
        endTime: 'End Time',
        userName: 'Publisher'
      },
      add: {
        title: 'Add Activity',
        titlePlaceholder: 'Required, please enter title',
        typeCd: 'Activity Type',
        startTime: 'start time',
        endTime: 'end time',
        typeCdPlaceholder: 'Required, please select type',
        isMoreCommunity: 'Multi-community',
        isMoreCommunityPlaceholder: 'Please select if multi-community',
        headerImg: 'Header Image (800*595)',
        startTimePlaceholder: 'Required, please enter start time',
        endTimePlaceholder: 'Required, please enter end time',
        signUpStartTime: 'Registration Start Time',
        signUpEndTime: 'Registration End Time',
        location: 'Location',
        signUpStartTimePlaceholder: 'Required, please enter registration start time',
        signUpEndTimePlaceholder: 'Required, please enter registration end time',
        locationPlaceholder: 'Required, please enter location',
        isCharge: 'Charge Fee',
        isChargePlaceholder: 'Please select if charge fee',
        feeAmount: 'Fee Amount',
        feeAmountPlaceholder: 'Required, please enter fee amount',
        feeAmountUnit: 'Yuan',
        hasSignUpLimit: 'Sign-up Limit',
        hasSignUpLimitPlaceholder: 'Please select if set sign-up limit',
        signUpLimit: 'Max Sign-ups',
        signUpLimitPlaceholder: 'Required, please enter max sign-ups',
        context: 'Content'
      },
      edit: {
        title: 'Edit Activity',
        titlePlaceholder: 'Required, please enter title',
        typeCd: 'Activity Type',
        startTime: 'start time',
        endTime: 'end time',
        typeCdPlaceholder: 'Required, please select type',
        headerImg: 'Header Image (800*595)',
        startTimePlaceholder: 'Required, please enter start time',
        endTimePlaceholder: 'Required, please enter end time',
        signUpStartTime: 'Registration Start Time',
        signUpEndTime: 'Registration End Time',
        location: 'Location',
        signUpStartTimePlaceholder: 'Required, please enter registration start time',
        signUpEndTimePlaceholder: 'Required, please enter registration end time',
        locationPlaceholder: 'Required, please enter location',
        isCharge: 'Charge Fee',
        isChargePlaceholder: 'Please select if charge fee',
        feeAmount: 'Fee Amount',
        feeAmountPlaceholder: 'Required, please enter fee amount',
        feeAmountUnit: 'Yuan',
        hasSignUpLimit: 'Sign-up Limit',
        hasSignUpLimitPlaceholder: 'Please select if set sign-up limit',
        signUpLimit: 'Max Sign-ups',
        signUpLimitPlaceholder: 'Required, please enter max sign-ups',
        context: 'Content'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this activity?'
      },
      validate: {
        titleRequired: 'Title is required',
        titleMaxLength: 'Title cannot exceed 200 characters',
        typeCdRequired: 'Type is required',
        headerImgRequired: 'Header image is required',
        contextRequired: 'Content is required',
        startTimeRequired: 'Start time is required',
        endTimeRequired: 'End time is required',
        signUpStartTimeRequired: 'Registration start time is required',
        signUpEndTimeRequired: 'Registration end time is required',
        locationRequired: 'Location is required',
        activitiesIdRequired: 'Activity ID is required',
        imageSize: 'Image size cannot exceed 2MB',
        feeAmountRequired: 'Fee amount is required',
        feeAmountInvalid: 'Fee amount must be greater than 0',
        signUpLimitRequired: 'Sign-up limit is required',
        signUpLimitInvalid: 'Sign-up limit must be a positive integer'
      }
    }
  },
  zh: {
    activitiesManage: {
      search: {
        title: '查询条件',
        activitiesId: '请输入活动ID',
        titlePlaceholder: '请输入标题',
        typeCd: '请选择活动类型',
        staffName: '请输入发布人名称'
      },
      list: {
        title: '活动列表'
      },
      table: {
        activitiesId: '活动ID',
        title: '标题',
        typeCd: '类型',
        startTime: '开始时间',
        endTime: '结束时间',
        userName: '发布人'
      },
      add: {
        title: '添加活动',
        titlePlaceholder: '必填，请输入标题',
        typeCd: '类型',
        startTime: '开始时间',
        endTime: '结束时间',
        typeCdPlaceholder: '必填，请选择类型',
        isMoreCommunity: '多小区',
        isMoreCommunityPlaceholder: '请选择是否多小区',
        headerImg: '头图',
        startTimePlaceholder: '必填，请输入开始时间',
        endTimePlaceholder: '必填，请输入结束时间',
        signUpStartTime: '报名开始时间',
        signUpEndTime: '报名结束时间',
        location: '活动地点',
        signUpStartTimePlaceholder: '必填，请输入报名开始时间',
        signUpEndTimePlaceholder: '必填，请输入报名结束时间',
        locationPlaceholder: '必填，请输入活动地点',
        isCharge: '是否收费',
        isChargePlaceholder: '请选择是否收费',
        feeAmount: '收费金额',
        feeAmountPlaceholder: '必填，请输入收费金额',
        feeAmountUnit: '元',
        hasSignUpLimit: '报名人数上限',
        hasSignUpLimitPlaceholder: '请选择是否设置报名人数上限',
        signUpLimit: '报名人数上限',
        signUpLimitPlaceholder: '必填，请输入报名人数上限',
        context: '内容'
      },
      edit: {
        title: '编辑活动',
        titlePlaceholder: '必填，请输入标题',
        typeCd: '类型',
        typeCdPlaceholder: '必填，请选择类型',
        headerImg: '头图',
        startTimePlaceholder: '必填，请输入开始时间',
        endTimePlaceholder: '必填，请输入结束时间',
        signUpStartTime: '报名开始时间',
        signUpEndTime: '报名结束时间',
        location: '活动地点',
        signUpStartTimePlaceholder: '必填，请输入报名开始时间',
        signUpEndTimePlaceholder: '必填，请输入报名结束时间',
        locationPlaceholder: '必填，请输入活动地点',
        startTime: '开始时间',
        endTime: '结束时间',
        isCharge: '是否收费',
        isChargePlaceholder: '请选择是否收费',
        feeAmount: '收费金额',
        feeAmountPlaceholder: '必填，请输入收费金额',
        feeAmountUnit: '元',
        hasSignUpLimit: '报名人数上限',
        hasSignUpLimitPlaceholder: '请选择是否设置报名人数上限',
        signUpLimit: '报名人数上限',
        signUpLimitPlaceholder: '必填，请输入报名人数上限',
        context: '内容'
      },
      delete: {
        title: '确认操作',
        confirmText: '确认删除该活动吗？'
      },
      validate: {
        titleRequired: '标题不能为空',
        titleMaxLength: '标题不能超过200个字符',
        typeCdRequired: '类型不能为空',
        headerImgRequired: '头部照片不能为空',
        contextRequired: '内容不能为空',
        startTimeRequired: '开始时间不能为空',
        endTimeRequired: '结束时间不能为空',
        signUpStartTimeRequired: '报名开始时间不能为空',
        signUpEndTimeRequired: '报名结束时间不能为空',
        locationRequired: '活动地点不能为空',
        activitiesIdRequired: '活动ID不能为空',
        imageSize: '图片大小不能超过2MB',
        feeAmountRequired: '收费金额不能为空',
        feeAmountInvalid: '收费金额必须大于0',
        signUpLimitRequired: '报名人数上限不能为空',
        signUpLimitInvalid: '报名人数上限必须为正整数'
      }
    }
  }
}